import store from './store';
import EntitySubscribers from './components/EntitySubscribers';
import Vue from 'vue';
import {isCtrlOrCmd, copyText, animateCopyIcon} from './utils';

export function postView(options) {
  store.commit('setCurrentProject', options.project);

  new Vue({
    el: '#entity-subscribers',
    render: h => h(EntitySubscribers, {
      props: {
        user: options.user,
        postId: options.post.id,
        subscribers: options.subscribers,
      },
    }),
  });

  const post = options.post;
  $('#copy-url-button').click(function(e) {
    e.preventDefault();
    const url = `${window.location.origin}/projects/${post.project.id}/chats/${post.postNumber}`;
    const markdown = `[C${post.postNumber}${isCtrlOrCmd(e) ? (' ' + post.title) : ''}](${url})`;
    copyText(markdown);
    animateCopyIcon($(this).find('.copy-icon i'));
  });
}



// WEBPACK FOOTER //
// ./assets/js/posts.js